
export default class CardInput {

  public title: string;
  public text: string;
  public image?: string;
  public link: string;
  public putZinfiLink?: boolean;

  constructor(title: string, text: string, link: string, image?: string, putZinfiLink?: boolean) {
    this.title = title;
    this.text = text;
    this.link = link;
    this.image = image;
    this.putZinfiLink = putZinfiLink;
  }

}
